import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

interface SidebarProps {
  currentSection: string;
  isOpen: boolean;
  isMobile: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentSection, isOpen, isMobile, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  
  const sections = [
    { path: '/', label: 'Overview' },
    { path: '/calendar', label: 'Calendar' },
    { path: '/events', label: 'Events' },
    { path: '/objectives', label: 'Objectives' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const handleSignOut = () => {
    logout();
    navigate('/login');
    if (isMobile) onClose();
  };

  return (
    <>
      {isMobile && isOpen && (
        <div className="sidebar-overlay" onClick={onClose} />
      )}
      <aside className={`sidebar ${isMobile && !isOpen ? 'hidden' : ''} ${isMobile ? 'mobile' : ''}`}>
        {isMobile && (
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">
            ×
          </button>
        )}
        <div className="brand">
          <h1 className="brand-title">2026 Roadmap</h1>
          <p className="brand-sub">AirPLAi Sports</p>
          <p className="brand-meta">Events & Objectives</p>
        </div>
        <nav className="nav">
          {sections.map(sec => (
            <Link
              key={sec.path}
              to={sec.path}
              className={isActive(sec.path) ? 'active' : ''}
              onClick={() => {
                if (isMobile) onClose();
              }}
            >
              {sec.label}
            </Link>
          ))}
          <button
            className="nav-signout"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;

